import { navigation } from '@/Navigation';
import yoda from '@kibt/bridge';

export function backOrClose(params: { closeWeb: boolean } = { closeWeb: false }) {
    const { closeWeb } = params;
    if (closeWeb) {
        yoda.component.backOrCloseWeb(params);
    } else {
        if (navigation.canGoBack()) {
            navigation.goBack();
        } else {
            yoda.component.backOrCloseWeb();
        }
    }
}
